module.exports = __webpack_public_path__ + "static/media/icon_dashboard.4f1f146b.svg";